export default class EnvConstants{
  // @ts-ignore
  static APP_DOMAIN = __APP_DOMAIN__;
  // @ts-ignore
  static readonly JS_DOMAIN = __JS_DOMAIN__;
  // @ts-ignore
  static readonly STATIC_DOMAIN = __STATIC_DOMAIN__;
  // @ts-ignore
  static readonly ASSET_PATH = `${__JS_DOMAIN__}${__PUBLIC_PATH__}`
}

export function isDev(): boolean {
  return process.env.NODE_ENV !== 'production'
}

export function debugMode(): boolean {
  return isDev() && !!process.env.DEBUG_MODE
}
